/* Keep native server-rendered product blocks intact for quick view and no-JS use. */
(function () {
  'use strict';

  var selector = '[data-emz-hybrid-product="true"]';
  var states = new WeakMap();

  function sectionsWithin(scope) {
    var sections = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) sections.unshift(scope);
    return sections;
  }

  function initialize(section) {
    if (states.has(section)) return;

    var grid = section.querySelector('.emz-hybrid-product-grid');
    var intro = section.querySelector('[data-emz-product-intro]');
    var header = section.querySelector('.product-single__meta > .product-block--header');
    var blocks = section.querySelector('[data-product-blocks]');
    var price = blocks && blocks.querySelector('.product-block--price');
    var media = grid && grid.querySelector('.emz-hybrid-product-media');
    var details = grid && grid.querySelector('.emz-hybrid-product-details');
    if (!grid || !intro || !header || !blocks || !media || !details) return;

    var moves = [];
    var generated = [];
    function move(node, parent, before) {
      var origin = document.createComment('emz-hybrid-origin');
      node.parentNode.insertBefore(origin, node);
      moves.push({ node: node, origin: origin });
      parent.insertBefore(node, before || null);
    }

    move(header, intro);
    if (price) move(price, intro);
    // Reading order stays intro, photograph, decisions for either desktop image side.
    if (media.nextElementSibling !== details) move(media, grid, details);

    // Move the existing social block after product information, retaining editor identity.
    // Server markup stays intact for quick view and the existing restore lifecycle.
    var tabs = details.querySelector('.emz-tabs-wrapper');
    var whole = section.getAttribute('data-emz-whole-product') === 'true';
    var information = section.querySelector('[data-emz-whole-information]');
    if (whole && tabs && information) {
      move(tabs, information);
    }
    if (section.getAttribute('data-modal') !== 'true' && tabs) {
      var afterTabs = tabs.nextSibling;
      Array.from(blocks.children).forEach(function (block) {
        if (block.classList.contains('product-block') && block.querySelector('.social-follow')) {
          move(block, tabs.parentNode, afterTabs);
        }
      });
    }

    // Keep native cross-sells after the story and information on every viewport.
    // Move the existing nodes so links, quick-add handlers and editor restoration survive.
    if (whole && tabs && information) {
      var follow = information.querySelector('.social-follow');
      var beforeFollow = follow && follow.closest('.product-block');
      Array.from(details.querySelector('.product-single__meta').children).forEach(function (block) {
        if (block.matches('.emz-closing-tagline, .emz-pairings-section')) {
          move(block, information, beforeFollow);
        }
      });
    }

    // Story previews read the same public description the uploader already supplies.
    // Never read internal maker-notes metafields or fall back to stale copied story text.
    var uploadedStory = section.querySelector('[data-emz-uploaded-story]');
    var uploadedSummary = section.querySelector('[data-emz-uploaded-summary]');
    var sourcePane = tabs && tabs.querySelector('#emz-tab-details');
    var sourceIntro = sourcePane && sourcePane.firstElementChild;
    var sourceBenefits = sourcePane && Array.from(sourcePane.children).find(function (node) {
      return node.classList.contains('rte') && node.querySelector('ul.benefits-list');
    });
    if (sourceIntro && sourceIntro.classList.contains('rte') &&
        !sourceIntro.classList.contains('rte--full-description') &&
        sourceBenefits && sourceBenefits !== sourceIntro) {
      var subheadline = sourceIntro.querySelector('p.product-subheadline');
      var storyParagraph = Array.from(sourceIntro.children).find(function (node) {
        return node.tagName === 'P' && node !== subheadline && node.textContent.trim();
      });
      var makerQuote = sourceIntro.querySelector('blockquote:not(.customer-testimonial)');
      function previewCopy(source, destination) {
        if (!source || !destination || source.querySelector('input,textarea,select,form')) return;
        var copy = source.cloneNode(true);
        copy.removeAttribute('id');
        Array.from(copy.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
        destination.appendChild(copy);
        generated.push(copy);
      }
      if (uploadedStory && storyParagraph) {
        previewCopy(storyParagraph, uploadedStory.querySelector('[data-emz-uploaded-story-text]'));
        previewCopy(makerQuote, uploadedStory.querySelector('[data-emz-uploaded-story-quote]'));
        uploadedStory.hidden = false;
      }
    }

    // A product's own public subheadline is independent of its optional story block.
    // Explicit markup only: never guess from the title, maker notes or another product.
    var summarySources = sourcePane && sourcePane.querySelectorAll('p.product-subheadline');
    if (uploadedSummary && summarySources && summarySources.length === 1) {
      var summarySource = summarySources[0];
      if (summarySource.textContent.trim() && !summarySource.querySelector('input,textarea,select,form')) {
        var summaryCopy = summarySource.cloneNode(true);
        summaryCopy.removeAttribute('id');
        Array.from(summaryCopy.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
        uploadedSummary.appendChild(summaryCopy);
        generated.push(summaryCopy);
        uploadedSummary.hidden = false;
      }
    }
    var visibleSummary = uploadedSummary && !uploadedSummary.hidden ? uploadedSummary : section.querySelector('[data-emz-manual-summary]');
    var detailsButton = tabs && tabs.querySelector('.emz-tab-btn[aria-controls="emz-tab-details"]');
    if (visibleSummary && detailsButton && sourcePane) {
      var detailsLink = document.createElement('a');
      detailsLink.className = 'emz-product-details-link';
      detailsLink.href = '#emz-tab-details';
      detailsLink.textContent = 'Explore the details ↓';
      detailsLink.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        detailsButton.click();
        detailsButton.focus({ preventScroll: true });
        tabs.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
      visibleSummary.insertAdjacentElement('afterend', detailsLink);
      generated.push(detailsLink);
    }

    // Enhance only the structured description produced by the existing tab parser.
    // Unknown/full-description formats remain completely visible.
    if (whole && tabs) {
      var pane = tabs.querySelector('#emz-tab-details');
      var introCopy = pane && pane.firstElementChild;
      var benefits = pane && Array.from(pane.children).find(function (node) {
        return node.classList.contains('rte') && node.querySelector('ul.benefits-list');
      });
      var opening = introCopy && introCopy.firstElementChild;
      if (introCopy && introCopy.classList.contains('rte') &&
          !introCopy.classList.contains('rte--full-description') &&
          benefits && benefits !== introCopy && opening && opening.tagName === 'P' &&
          opening.textContent.trim().length > 0 && opening.textContent.trim().length < 450) {
        var tail = Array.from(introCopy.childNodes).slice(Array.from(introCopy.childNodes).indexOf(opening) + 1);
        var tailLength = tail.map(function (node) { return node.textContent; }).join('').trim().length;
        if (tailLength > 250) {
          var later = [];
          var next = benefits.nextSibling;
          while (next) { later.push(next); next = next.nextSibling; }
          var disclosure = document.createElement('details');
          disclosure.className = 'emz-details-story';
          var summary = document.createElement('summary');
          summary.textContent = 'Read the full story';
          disclosure.appendChild(summary);
          var storyBody = document.createElement('div');
          storyBody.className = 'emz-details-story-body';
          var narrative = document.createElement('div');
          narrative.className = 'rte';
          storyBody.appendChild(narrative);
          disclosure.appendChild(storyBody);
          pane.appendChild(disclosure);
          generated.push(disclosure);
          tail.forEach(function (node) { move(node, narrative); });
          later.forEach(function (node) { move(node, storyBody); });
        }
      }
    }

    states.set(section, { moves: moves, generated: generated });
    intro.hidden = false;
    section.classList.add('emz-hybrid-product-ready');
  }

  function restore(section) {
    var state = states.get(section);
    if (!state) return;
    state.moves.forEach(function (move) {
      if (move.origin.parentNode) {
        move.origin.parentNode.insertBefore(move.node, move.origin);
        move.origin.remove();
      }
    });
    state.generated.forEach(function (node) { node.remove(); });
    Array.from(section.querySelectorAll('[data-emz-uploaded-story], [data-emz-uploaded-summary]')).forEach(function (node) { node.hidden = true; });
    var intro = section.querySelector('[data-emz-product-intro]');
    if (intro) intro.hidden = true;
    section.classList.remove('emz-hybrid-product-ready');
    states.delete(section);
  }

  function initializeWithin(scope) {
    sectionsWithin(scope).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    sectionsWithin(event.target).forEach(restore);
  });
}());
